<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card class="elevation-12">
              <v-item-group v-model="selectedOption">
                <v-container>
                  <v-row>
                    <v-col cols="12" :md="!ParametrosGeneralesAmb.imprimeTicketTotem || esElectron ? 4 : 6">
                      <v-item v-slot:default="{ active, toggle }" value="recepcion">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          height="100"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              class="title flex-grow-1 text-center"
                              :class="{'white--text': active}"
                            >Puesto en recepción</div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                    <v-col cols="12" :md="!ParametrosGeneralesAmb.imprimeTicketTotem || esElectron ? 4 : 6">
                      <v-item v-slot:default="{ active, toggle }" value="monitor">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          height="100"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              class="title flex-grow-1 text-center"
                              :class="{'white--text': active}"
                            >Monitor en sala</div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                    <v-col cols="12" md="4" v-if="!ParametrosGeneralesAmb.imprimeTicketTotem || esElectron">
                      <v-item v-slot:default="{ active, toggle }" value="totem">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          height="100"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              class="title flex-grow-1 text-center"
                              :class="{'white--text': active}"
                            >Autorrecepción</div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
              <v-card-text>
                <v-form>
                  <v-select
                    :items="salasNoAdministrativas"
                    v-model="salaActual"
                    return-object
                    item-text="salaNombre"
                    label="Sala espera"
                  ></v-select>
                  <v-select
                    :items="terminales"
                    v-model="terminalActual"
                    return-object
                    item-text="nombre"
                    item-value="totemId"
                    label="Terminal"
                    v-show="totemSetUp"
                  ></v-select>
                  <v-select
                    v-show="monitorSetUp"
                    :items="tipos"
                    v-model="selectedTipo"
                    item-text="name"
                    item-value="id"
                    label="Tipo"
                  ></v-select>
                  <v-select
                    v-show="monitorSetUp && selectedTipo == 1"
                    :items="estilos"
                    v-model="selectedEstilo"
                    item-text="name"
                    item-value="id"
                    label="Estilo"
                  ></v-select>
                  <v-select
                    v-show="monitorSetUp && selectedTipo == 1 && selectedEstilo === 2"
                    :items="mediaItems"
                    v-model="selectedMedia"
                    item-text="name"
                    item-value="id"
                    label="Contenido"
                  ></v-select>
                  <v-select
                    v-show="recepcionSetUp"
                    :items="puestos"
                    v-model="puestoActual"
                    return-object
                    item-text="value"
                    label="Puesto"
                  ></v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn :disabled="disabledBtnIniciar" color="primary" @click="confirm">Iniciar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      selectedOption: null,
      recepcionSetUp: false,
      monitorSetUp: false,
      totemSetUp: false,
      salaActual: null,
      salaActualAdministrativa: {},
      puestoActual: null,
      selectedEstilo: 1,
      selectedTipo: 0,
      selectedMedia: '',
      mediaItems: [],
      mainColor: this.$vuetify.theme.themes.light.primary,
      terminalActual: null
    }
  },
  watch: {
    getApiUrl: function (val) {
      if (val) this.initialConfig()
    },
    salaActual: function () {
      var vm = this
      vm.getPuestos()
    },
    mainColor: function () {
      this.setColor()
    },
    selectedOption: function () {
      var vm = this
      vm.recepcionSetUp = vm.selectedOption === 'recepcion'
      vm.monitorSetUp = vm.selectedOption === 'monitor'
      vm.totemSetUp = vm.selectedOption === 'totem'
    }
  },
  computed: {
    ...mapGetters(['getApiUrl']),
    ...mapState('InitConfig', [
      'salasNoAdministrativas',
      'salasAdministrativas',
      'estilos',
      'tipos',
      'puestos',
      'media',
      'terminales',
      'apiUrl',
      'ParametrosGeneralesAmb'
    ]),
    esElectron () {
      return typeof process !== 'undefined' && process.type === 'renderer'
    },
    disabledBtnIniciar () {
      if (!this.selectedOption && !this.salaActual) return true
      if (this.selectedOption === 'recepcion' && !this.puestoActual) return true
      if (this.selectedOption === 'monitor' && !this.selectedTipo) return true
      if (this.selectedOption === 'totem' && !this.terminalActual) return true
      return false
    }
  },
  mounted () {
    this.initialConfig()
  },
  methods: {
    ...mapActions('GeneralAR', ['fetchMensajes', 'fetchAccionesAR']),
    ...mapActions('InitConfig', [
      'setSala',
      'setSalaAdministrativa',
      'fetchSalas',
      'setPuesto',
      'fetchPuestos',
      'fetchMedia',
      'fetchParametrosGeneralesAmb',
      'fetchTerminales'
    ]),
    ...mapMutations('InitConfig', [
      'setTipo',
      'setEstilo',
      'setPuestos',
      'setSelectedMedia',
      'setTerminal'
    ]),
    initialConfig () {
      var vm = this
      vm.getSalasEspera()
      vm.getMedia()
      vm.fetchParametrosGeneralesAmb()
      vm.fetchMensajes()
      vm.getTerminales()
    },
    getSalasEspera () {
      var vm = this
      vm.fetchSalas().then(() => {
        vm.getPuestos()
      })
    },
    getMedia () {
      var vm = this
      vm.fetchMedia().then(() => {
        vm.setColor(vm.media.primaryColor)
        if (vm.media.youTubeUrl !== null) {
          vm.mediaItems.push({ id: 'youTubeUrl', name: 'YouTube' })
        }
        if (vm.media.video !== null) {
          vm.mediaItems.push({ id: 'video', name: 'Video local' })
        }
        if (vm.media.images !== null && vm.media.images.length > 0) {
          vm.mediaItems.push({ id: 'images', name: 'Imágenes' })
        }
        if (vm.mediaItems.length === 1) {
          vm.selectedMedia = vm.mediaItems[0].id
        }
      })
    },
    getPuestos () {
      var vm = this
      vm.setPuestos([])
      if (vm.salaActual && vm.salaActual.salaId > 0) {
        vm.fetchPuestos(vm.salaActual.salaId)
      }
    },
    getTerminales () {
      var vm = this
      vm.fetchTerminales()
    },
    confirm: function () {
      var vm = this
      if (vm.selectedOption === 'recepcion') {
        if (
          vm.salaActual &&
          vm.salaActual.salaId > 0 &&
          vm.puestoActual &&
          vm.puestoActual.id > 0
        ) {
          vm.setSala(vm.salaActual)
          vm.setPuesto(vm.puestoActual)
          vm.$router.push({ name: 'NumerosRecepcion' })
        }
      } else if (vm.selectedOption === 'monitor') {
        var tipo = vm.tipos.filter(function (tipo) {
          return tipo.id === vm.selectedTipo
        })[0]
        var estilo = vm.estilos.filter(function (estilo) {
          return estilo.id === vm.selectedEstilo
        })[0]
        if (vm.salaActual?.salaId > 0 && vm.selectedTipo !== 0 // &&
        ) {
          // (vm.selectedTipo === 1 || vm.selectedMedia !== '')
          vm.setSala(vm.salaActual)
          vm.setTipo(tipo)
          vm.setEstilo(estilo)
          vm.setSelectedMedia(vm.selectedMedia)
          vm.$router.push({ name: 'Llamadas' })
        }
      } else if (vm.selectedOption === 'totem') {
        this.fetchAccionesAR(this.terminalActual)
        this.setTerminal(this.terminalActual)
        if (vm.salaActual && vm.salaActual.salaId > 0) {
          document.addEventListener('contextmenu', event =>
            event.preventDefault()
          )
          vm.setSala(vm.salaActual)
          vm.$router.push({ name: 'TotemHome' })
        }
      }
    },
    setColor (color) {
      if (/^#([0-9A-F]{3}){1,2}$/i.test(color)) {
        this.$vuetify.theme.themes.light.primary = color
      }
    }
  }
}
</script>
